export class PatientDetails {
  id?: number;
  mrn?: any;
  pid?: string;
  patientCkey?: number;
  name?: string;
  birthDate?: string;
  gender?: string;

  constructor(
    id?: number,
    mrn?: any,
    pid?: string,
    patientCkey?: number,
    name?: string,
    dob?: string,
    gender?: string
  ) {
    this.id = id;
    this.mrn = mrn;
    this.pid = pid;
    this.patientCkey = patientCkey;
    this.name = name;
    this.birthDate = dob;
    this.gender = gender;
  }
}
